<template>
    <div ref="container" class="relative h-full">
        <div
            ref="full"
            class="absolute inset-x-0 top-1/2 -translate-y-1/2"
            :class="{ invisible: isCompact }"
            :aria-hidden="isCompact ? 'true' : undefined"
            :inert="isCompact ? '' : undefined"
        >
            <slot name="full" />
        </div>
        <div v-if="isCompact" class="absolute inset-x-0 top-1/2 -translate-y-1/2">
            <slot name="compact" />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isCompact: false,
            };
        },

        methods: {
            // Always measure the full version so compact mode cannot cause a toggle loop.
            updateFit() {
                const availableHeight = this.$refs.container.clientHeight;

                if (availableHeight > 0) {
                    this.isCompact = this.$refs.full.getBoundingClientRect().height > availableHeight;
                }
            },
        },

        mounted() {
            this.resizeObserver = new ResizeObserver(this.updateFit);
            this.resizeObserver.observe(this.$refs.container);
            this.resizeObserver.observe(this.$refs.full);
            this.updateFit();
        },

        beforeUnmount() {
            this.resizeObserver.disconnect();
        },
    };
</script>
